/**
 * Online Order Form DB Service REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OofOrderItemConfigurationDto } from './oofOrderItemConfigurationDto';


export interface OrderItemConfigurationModificationResultDto { 
    modifiedOrderItemConfig?: OofOrderItemConfigurationDto;
    orderItemStatus?: OrderItemConfigurationModificationResultDto.OrderItemStatusEnum;
}
export namespace OrderItemConfigurationModificationResultDto {
    export const OrderItemStatusEnum = {
        Incomplete: 'INCOMPLETE',
        Fulfilled: 'FULFILLED',
        Submitted: 'SUBMITTED',
        InProduction: 'IN_PRODUCTION',
        Packed: 'PACKED',
        Shipped: 'SHIPPED',
        Canceled: 'CANCELED'
    } as const;
    export type OrderItemStatusEnum = typeof OrderItemStatusEnum[keyof typeof OrderItemStatusEnum];
}


